import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import styles from "./Tag.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";

type TagProps = {
  name: string;
  icon?: string;
};

const TagV2 = ({ name, icon = "" }: TagProps) => {
  const { t } = useTranslationHook();
  const isDesktop = useIsDesktop();
  const translateSQM = (stringName: string) => stringName?.replace(/\bsqm\s*$/i, t("sqm"));
  return (
    <div className={formatClassNames(styles.tag, isDesktop && styles.desktop)}>
      <LazyLoadOnScroll
        customRootMargin="0px"
        fallback={
          <section
            style={{
              height: "16px",
              width: "16px",
            }}
          />
        }
      >
        <span className={styles.icon}>{icon}</span>
      </LazyLoadOnScroll>
      <div data-testid="property-room-type-tenancy-amenities" className={styles.tagName}>
        {translateSQM(t(name))}
      </div>
    </div>
  );
};

export default wrapperHOC(TagV2, {
  componentName: "Tag-RoomTypeCard-RoomTypeSection-PropertyPage",
  showForChina: true,
});
